import type { LoadingCircleProps } from '@/components/loading-circle/loading-circle.types';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import '@/components/loading-circle/loading-circle-v1.css';
import '@/components/loading-circle/loading-circle-v2.css';

const LoadingCircle = forwardRef<HTMLDivElement, LoadingCircleProps>(function (props, ref) {
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);

  return (
    <div
      ref={ref}
      data-css-version={cssVersion}
      className={clsx('loading-circle', props.className, {
        'loading-circle--completed': props.success || props.fail,
        'loading-circle--failed': props.fail && !props.success,
      })}
    >
      <div
        className={clsx('loading-circle__icon', {
          'loading-circle__icon--show': props.success || props.fail,
          'loading-circle__icon--checkmark': props.success && !props.fail,
          'loading-circle__icon--cross': props.fail && !props.success,
        })}
      />
    </div>
  );
});

export default LoadingCircle;
